import React from "react";
import {TextField} from "@mui/material";
import {menuItemsInfo} from "../editMenuItems";
import {fieldSx} from "../editMenuStyles";
import {SectionHeader, ToggleRow} from "../components/EditMenuSection";

export const SettingsRefactoredTab = ({node, setNode, onUpdate}) => {
    const onChangeData = (key, value) => {
        setNode(prev => {
            const state = {...prev};
            state.data[key] = value;
            return state;
        });
    };

    const {primary, secondary} = menuItemsInfo.settings_refactored;

    return (
        <>
            <SectionHeader title={primary} description={secondary}/>

            <TextField
                value={node?.data?.max_ttl || ""}
                size="small"
                type="number"
                label="Max TTL"
                placeholder="Enter number"
                helperText="Maximum attempts to understand user"
                sx={fieldSx}
                onChange={e => onChangeData("max_ttl", e.target.value)}
                onBlur={() => onUpdate(node)}
            />

            <ToggleRow
                control="checkbox"
                label="Use Hint"
                checked={node?.data?.hint}
                onChange={(event) => onChangeData("hint", event.target.checked)}
                onBlur={() => onUpdate(node)}
            />
            <ToggleRow
                control="checkbox"
                label="Share Conversation Context"
                checked={node?.data?.share_conversation_context}
                onChange={(event) => onChangeData("share_conversation_context", event.target.checked)}
                onBlur={() => onUpdate(node)}
            />

            <TextField
                type="number"
                value={node?.data?.conversation_buffer_window}
                size="small"
                label="Conversation buffer window"
                placeholder="Buffer window"
                helperText={node?.data?.share_conversation_context ? "" : "Only used when context sharing is on"}
                sx={fieldSx}
                onChange={(e) => onChangeData("conversation_buffer_window", e.target.value)}
                onBlur={() => onUpdate(node)}
            />
        </>
    );
};
